Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
});
$('body').on('click touchstart', function () {
    const videoElement = document.getElementById('ID_of_video');
    if (videoElement.playing) {
     
    }
    else {
        videoElement.play();
    }
});